export default __webpack_public_path__ + "static/media/no_cashback.7ab399da.svg";